/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import StudentRouteLinkItem from './StudentRouteLinkItem';
import BehaviorIcon from 'icons/BehaviorIcon';

const messages = defineMessages({
  title: {id: 'navigation.behavior'},
});

const BehaviorItem = () => (
  <StudentRouteLinkItem
    iconBefore={BehaviorIcon}
    route="midas/student/behavior"
    title={messages.title}
  />
);

export default BehaviorItem;
